// components/shared/Select.jsx
export function Select({
  label,
  name,
  value,
  onChange,
  options = [],
  error,
  required = false,
  disabled = false,
  primaryColor = "#ea580c",
  placeholder = "Seleccionar...",
  className = "",
}) {
  const id = `select-${name}`;
  const describedBy = error ? `${id}-error` : undefined;

  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="block text-sm font-semibold mb-2" style={{ color: primaryColor }}>
          {label} {required && <span className="text-red-400">*</span>}
        </label>
      )}

      <select
        id={id}
        name={name}
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        required={required}
        disabled={disabled}
        aria-invalid={!!error}
        aria-describedby={describedBy}
        className={`w-full px-4 py-2.5 bg-slate-800/40 border text-white rounded-xl
          focus:ring-2 focus:border-transparent transition
          disabled:opacity-50 disabled:cursor-not-allowed
          ${error ? "border-red-500" : "border-slate-700"}`}
        style={{ "--tw-ring-color": primaryColor }}
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {error && (
        <p id={describedBy} className="text-red-400 text-xs mt-1.5">
          {error}
        </p>
      )}
    </div>
  );
}
